import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['overlay', 'iframe'];

  connect() {
    this._previousBodyOverflow = document.body.style.overflow;
  }

  open() {
    // iframe が未ロードの場合、data-src から初めてロード
    if (this.hasIframeTarget && !this.iframeTarget.src && this.iframeTarget.dataset.src) {
      this.iframeTarget.src = this.iframeTarget.dataset.src;
    }
    this.overlayTarget.classList.remove('hidden');
    this._previousBodyOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
  }

  close() {
    this.overlayTarget.classList.add('hidden');
    document.body.style.overflow = this._previousBodyOverflow || '';
  }

  closeOnBackdrop(event) {
    if (event.target === this.overlayTarget) {
      this.close();
    }
  }
}
